export class MathUtils {
    private static DEC_PLACES_MULTIPLIER: number[] = [
        1,
        10,
        100,
        1000,
        10000,
        100000,
        1000000
    ];

    //-------------------------------------------------------------------------
    /**
     * Zaokrouhleni cisla na pozadovany pocet desetinnych mist
     * @param val Cislo, ktere chceme zaokrouhlit
     * @param placeCnt Pocet desetinnych mist
     * @returns 
     */
    //-------------------------------------------------------------------------
    static roundToXDecPlaces(val: number, placeCnt: number): number {
        if (placeCnt >= MathUtils.DEC_PLACES_MULTIPLIER.length)
            placeCnt = MathUtils.DEC_PLACES_MULTIPLIER.length - 1;

        let multiplier = MathUtils.DEC_PLACES_MULTIPLIER[placeCnt];

        return Math.round(val * multiplier) / multiplier;
    }
}